import Icon from "../icons/Icon";

const SIZES = [24, 32, 40, 48, 56, 72, 128];
const TONES = ["rose", "indigo", "mint", "amber"];

const initialsOf = (name = "") =>
  name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "--";

// Deterministic tone: the same name always gets the same colour.
export const toneOf = (seed = "") => {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) h = Math.imul(h ^ seed.charCodeAt(i), 16777619);
  h ^= h >>> 15;
  return TONES[(h >>> 0) % TONES.length];
};

// People are circles; company logos pass shape="square" (rounded corners).
// `initials` overrides the derived value when the caller already has it.
// `tone` (rose | indigo | mint | amber) overrides the name-derived tone;
// `icon` renders a registered icon name instead of initials.
export default function Avatar({ src, name, initials, size = 48, shape = "circle", tone, icon, className = "", children }) {
  const px = SIZES.includes(size) ? size : 48;
  const resolvedTone = tone || toneOf(name || initials || "");
  const classes = [
    "rl-avatar", `rl-avatar--${px}`, `rl-avatar--${resolvedTone}`,
    shape === "square" ? "rl-avatar--square" : "", src ? "rl-avatar--has-img" : "", className,
  ].filter(Boolean).join(" ");
  const content = src
    ? <img src={src} alt="" className="rl-avatar__img" />
    : icon ? <Icon name={icon} size={Math.round(px * 0.45)} /> : children || initials || initialsOf(name);
  return <span className={classes}>{content}</span>;
}
